import { render, staticRenderFns } from "./WWWRequestList.vue?vue&type=template&id=0c2394c1"
import script from "./WWWRequestList.vue?vue&type=script&lang=ts"
export * from "./WWWRequestList.vue?vue&type=script&lang=ts"
import style0 from "./WWWRequestList.vue?vue&type=style&index=0&id=0c2394c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports